import {
  firestoreLite,
  collection,
  writeBatch,
  updateDoc,
  getDocs,
  getDoc,
  query,
  where,
  doc,
  documentId,
  collectionGroup,
  orderBy
} from '../../utils/firestoreLite'
import { getUser } from '../../redux/global'
// import { currentJobs } from '../../services/reports/jobStatistic'
import * as constants from '../../irmlib/src/common/constants'
import { skpApiSettings } from '../common/appConstants.js'
import { getCache, addCache } from './cache'

const getTemplateTypesForWmsCacheMs = 60 * 60 * 1000
const GDE_JOB = 'gdeJobs'
const GDE_JOB_LITE = 'gdeJobTable'
const GDE_TEMPLATES = 'gdeTemplates'
const GDE_JOB_BOXES = 'gdeBoxes'
const GDE_BOX_FILES = 'gdeFiles'
const LOCATIONS = 'locations'
const GDE_JOB_ACTIVITY = 'gdeActivities'
const GDE_JOB_SMART_CATALOG = 'smartCatalog'
const GDE_JOB_REQUEST = 'requests'
const GDE_SC_TEMPLATE = 'templates'
const SMART_CATALOG_ACTIVITY = 'activities'
const SMART_CATALOG_IMAGES = 'images'
const GDE_SMART_CATALOG_WMSRESPONSE = 'wmsResponse'
const GDE_SMART_CATALOG_BULK_BOX_TRANSMITTAL = 'bulkTransmittalUpload'

export const getTemplateTypesForWms = async wms => {
  const key = 'getTemplateTypesForWms'
  let data = getCache(key, wms)
  if (data) {
    return data
  }
  const standTemplateQuery = query(collection(firestoreLite, GDE_TEMPLATES), where('templateType', '==', 'STANDARD'), where('wmsCode', 'in', [wms]))
  data = await getDocs(standTemplateQuery)
  addCache(key, wms, data, getTemplateTypesForWmsCacheMs)
  return data
}

export const getTemplatesForDeType = async (deType, wms) => {
  const templateQuery = query(collection(firestoreLite, GDE_TEMPLATES), where('dataEntryType', '==', deType), where('wmsCode', '==', wms?.toUpperCase()))
  return getDocs(templateQuery)
}

export const getTemplateType = async () => {
  const templateType = query(collection(firestoreLite, GDE_TEMPLATES))
  return getDocs(templateType)
}

export const getDistrictsByCountry = async (countryName) => {
  const locationsQuery = query(collection(firestoreLite, LOCATIONS), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getDistricts = async () => {
  const locationsQuery = query(collection(firestoreLite, LOCATIONS))
  return getDocs(locationsQuery)
}

export const getworkersLists = async (district) => {
  const workersDoc = []
  const rolesQuery = query(collectionGroup(firestoreLite, 'workerRoles'), where('activityFamilyId', '==', 'gde'), where('district', 'array-contains', district))
  const workerRoleDoc = await getDocs(rolesQuery)
  workerRoleDoc.forEach(async (role) => {
    workersDoc.push(getDoc(doc(firestoreLite, role.ref.parent.parent.path)))
  })
  const workers = await Promise.all(workersDoc)
  return workers
}

export const getJobsForQC = async (val) => {
  const arguments1 = []
  arguments1[0] = collection(firestoreLite, GDE_JOB)
  if (val !== undefined) {
    let a = 0
    if (val.jobId !== constants.defaultSelect && val.jobId !== undefined) {
      arguments1[++a] = where('jobId', '==', val.jobId)
    }
    if (
      val.customer !== constants.defaultForAccountLevel &&
      val.customer !== undefined &&
      val.customer !== constants.defaultSelect
    ) {
      arguments1[++a] = where('accountLevel1', '==', val.customer.toUpperCase())
    }

    if (
      val.templateNAme !== constants.defaultSelect &&
      val.templateNAme !== undefined
    ) {
      arguments1[++a] = where('templateName', '==', val.templateNAme)
    }

    if (val.deType !== constants.defaultSelect && val.deType !== undefined) {
      arguments1[++a] = where('dataEntryType', '==', val.deType)
    }
    if (val.districts.length > 0) {
      arguments1[++a] = where('districtId', 'in', val.districts)
    }

    if (
      val.userName !== constants.defaultSelect &&
      val.userName !== undefined
    ) {
      arguments1[++a] = where(
        'assignedUserList',
        'array-contains',
        val.userName
      )
    }
    arguments1[++a] = where('jobStatus', '==', 'In Process')
  }
  const standTemplateQuery = query.apply(null, arguments1)
  return await getDocs(standTemplateQuery)
}

export const getJobsWithBoxesQC = async (status, districtList) => {
  const collectionQuery = query(
    collectionGroup(firestoreLite, GDE_JOB_BOXES),
    where('status', 'in', status),
    where('districtId', 'in', districtList))
  return getDocs(collectionQuery)
}

const QUALITY_HUB_FIRESTORE_IN_MAX = 30

const chunkForQualityHubFirestoreIn = (values) => {
  const chunks = []
  for (let i = 0; i < values.length; i += QUALITY_HUB_FIRESTORE_IN_MAX) {
    chunks.push(values.slice(i, i + QUALITY_HUB_FIRESTORE_IN_MAX))
  }
  return chunks
}

/** Same filter shape as {@link getJobsForQC}; isolated for Hub batched-by-id reads only. */
const buildQualityHubJobsForQCQueryParts = (val) => {
  const arguments1 = []
  arguments1[0] = collection(firestoreLite, GDE_JOB)
  if (val !== undefined) {
    let a = 0
    if (val.jobId !== constants.defaultSelect && val.jobId !== undefined) {
      arguments1[++a] = where('jobId', '==', val.jobId)
    }
    if (
      val.customer !== constants.defaultForAccountLevel &&
      val.customer !== undefined &&
      val.customer !== constants.defaultSelect
    ) {
      arguments1[++a] = where('accountLevel1', '==', val.customer.toUpperCase())
    }

    if (
      val.templateNAme !== constants.defaultSelect &&
      val.templateNAme !== undefined
    ) {
      arguments1[++a] = where('templateName', '==', val.templateNAme)
    }

    if (val.deType !== constants.defaultSelect && val.deType !== undefined) {
      arguments1[++a] = where('dataEntryType', '==', val.deType)
    }
    if (val.districts.length > 0) {
      arguments1[++a] = where('districtId', 'in', val.districts)
    }

    if (
      val.userName !== constants.defaultSelect &&
      val.userName !== undefined
    ) {
      arguments1[++a] = where(
        'assignedUserList',
        'array-contains',
        val.userName
      )
    }
    arguments1[++a] = where('jobStatus', '==', 'In Process')
  }
  return arguments1
}

/**
 * Quality Hub: collection-group box query with district `in` chunked (max 30) and parallel chunks.
 * Returns `{ docs }` for the same iteration pattern as `QuerySnapshot.docs`.
 */
export const getQualityHubBoxesInQcStatuses = async (status, districtList) => {
  const districts = [...new Set((districtList || []).filter((d) => d != null && d !== ''))]
  if (!districts.length || !status?.length) {
    return { docs: [] }
  }
  const districtChunks = chunkForQualityHubFirestoreIn(districts)
  const snaps = await Promise.all(
    districtChunks.map((chunk) =>
      getDocs(
        query(
          collectionGroup(firestoreLite, GDE_JOB_BOXES),
          where('status', 'in', status),
          where('districtId', 'in', chunk)
        )
      )
    )
  )
  return { docs: snaps.flatMap((s) => s.docs) }
}

/**
 * Quality Hub: fetch job docs by id with the same filters as {@link getJobsForQC}, batched on `documentId`.
 * May require a Firestore composite index; callers should fall back to {@link getJobsForQC} + filter if needed.
 */
export const getQualityHubJobsForQCByJobIds = async (val, jobIds) => {
  const ids = [...jobIds]
  if (ids.length === 0) {
    return []
  }
  const parts = buildQualityHubJobsForQCQueryParts(val)
  const coll = parts[0]
  const filters = parts.slice(1)
  const idBatches = chunkForQualityHubFirestoreIn(ids)
  const snaps = await Promise.all(
    idBatches.map((batch) =>
      getDocs(query(coll, where(documentId(), 'in', batch), ...filters))
    )
  )
  return snaps.flatMap((s) => s.docs)
}

export const getJobsWithExceptionBoxes = async (status, loggedInUserDistrict) => {
  const collectionQuery = query(
    collectionGroup(firestoreLite, GDE_JOB_BOXES),
    where('status', '==', status), where('districtId', '==', loggedInUserDistrict)
  )
  return getDocs(collectionQuery)
}

export const getBoxesForJob = async (jobId) => {
  const boxQuery = query(
    collection(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`)
  )
  return getDocs(boxQuery)
}

export const getRequestById = async (requestId) => {
  const boxQuery = await getDoc(doc(firestoreLite, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, 
    requestId)
  )
  return boxQuery.data()
}

export const getTemplateById = async (requestId) => {
  const templateQuery = await getDoc(doc(firestoreLite, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`, 
    requestId)
  )
  return templateQuery.data()
}

// export const getGdeActivity = async (val) => {
//   const userval = getUser()
//   const loggedInUserDistrict = userval.district
//   const conditions = []
//   conditions[0] = collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_REQUEST)
//   let index = 0
//   conditions[++index] = where('srcSystem', '==', 'gde')
//   if (
//     val.status === constants.defaultSelect &&
//     val.districts[0] === constants.defaultSelect
//   ) {
//     conditions[++index] = where('status', 'in', ['pending', 'In Progress'])
//     conditions[++index] = where('district', '==', loggedInUserDistrict)
//   } else {
//     if (val.status !== constants.defaultSelect) {
//       if (Array.isArray(val.status)) {
//         conditions[++index] = where('status', 'in', val.status)
//       } else {
//         conditions[++index] = where('status', '==', val.status)
//       }
//       if (val.districts[0] === constants.defaultSelect) {
//         conditions[++index] = where('district', '==', loggedInUserDistrict)
//       }
//     }
//     if (val.districts[0] !== constants.defaultSelect) {
//       conditions[++index] = where('district', 'in', val.districts)
//       if (val.status === constants.defaultSelect) {
//         conditions[++index] = where('status', 'in', ['pending', 'In Progress'])
//       }
//     }
//   }
//   const standTemplateQuery = query.apply(null, conditions)
//   return await getDocs(standTemplateQuery)
// }

export const getRequestTemplates = async (val) => {
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  const conditions = []
  conditions[0] = collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
  let index = 0
  conditions[++index] = where('srcSystem', '==', 'gde')
  if (
    val.status === constants.defaultSelect &&
    val.districts[0] === constants.defaultSelect
  ) {
    conditions[++index] = where('status', '==', 'pending')
    conditions[++index] = where('district', '==', loggedInUserDistrict)
  } else {
    if (val.status !== constants.defaultSelect) {
      if (Array.isArray(val.status)) {
        conditions[++index] = where('status', 'in', val.status)
      } else {
        conditions[++index] = where('status', '==', val.status)
      }
      if (val.districts[0] === constants.defaultSelect) {
        conditions[++index] = where('district', '==', loggedInUserDistrict)
      }
    }
    if (val.districts[0] !== constants.defaultSelect) {
      conditions[++index] = where('district', 'in', val.districts)
      if (val.status === constants.defaultSelect) {
        conditions[++index] = where('status', '==', 'pending')
      }
    }
  }
  const standTemplateQuery = query.apply(null, conditions)
  return await getDocs(standTemplateQuery)
}

export const getImages = async (activityId, boxId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES),
    where('activityId', '==', activityId), 
    where('skpBoxNbr', '==', boxId))
  return getDocs(requestQuery)
}
export const getImagByActivityId = async (activityId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES),
    where('activityId', '==', activityId))
  return getDocs(requestQuery)
}

export const getActivityFromImages = async (requestId, skpBoxnum) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES),
    where('requestId', '==', requestId),
    // where('isActive', '==', true),
    // where('skpBoxNbr', '==', skpBoxnum)
    // where('status', '==', 'completed')
  )
  return getDocs(requestQuery)
}

export const getSubActivity = async (requestId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_ACTIVITY),
    where('requestId', '==', requestId))
  return getDocs(requestQuery)
}

export const getBoxActivity = async (requestId, boxId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_ACTIVITY),
    where('requestId', '==', requestId), where('skpBoxNbr', '==', boxId))
  return getDocs(requestQuery)
}

export const getBoxById = async (boxId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_ACTIVITY), where('skpBoxNbr', '==', boxId), where('status', 'in', ['pending', 'In Progress', 'failed']))
  return getDocs(requestQuery)
}

export const getImagesByActivityId = async (activityId, reqId) => {
  const requestQuery = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, SMART_CATALOG_IMAGES), where('activityId', '==', activityId), orderBy('createTS', 'asc'))
  return getDocs(requestQuery)
}

export const getQueryDataJob2 = async (val, user) => {
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  if (
    val.jobStatus === 'Assigned, In Process' ||
    val.jobStatus === 'Pending, Assigned, In Process'
  ) {
    if (val.jobStatus === 'Assigned, In Process') {
      const arguments1 = []
      arguments1[0] = collection(firestoreLite, GDE_JOB_LITE)
      let a = 0
      arguments1[++a] = where('jobStatus', 'in', [
        constants.jobStatus.assigned,
        constants.jobStatus.inProgress
      ])
      if (user) {
        arguments1[++a] = where('assignedUserList', 'array-contains', user)
      }
      arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
      const standTemplateQuery = query.apply(null, arguments1)
      return await getDocs(standTemplateQuery)
    }
    if (val.jobStatus === 'Pending, Assigned, In Process') {
      const arguments1 = []
      arguments1[0] = collection(firestoreLite, GDE_JOB_LITE)
      let a = 0
      arguments1[++a] = where('jobStatus', 'in', [
        constants.jobStatus.assigned,
        constants.jobStatus.inProgress,
        constants.jobStatus.pending
      ])
      if (user) {
        arguments1[++a] = where('assignedUserList', 'array-contains', user)
      }
      arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
      const standTemplateQuery = query.apply(null, arguments1)
      return await getDocs(standTemplateQuery)
    }
  } else {
    // filter options
    const arguments1 = []
    arguments1[0] = collection(firestoreLite, GDE_JOB_LITE)
    let a = 0

    if (user) {
      // filter for my jobs
      if (val.initialStatus === 'NoApprove') {
        arguments1[++a] = where(
          'jobStatus',
          'in',
          constants.activeJobStatus
        )
      }
      // if (
      //   val.userName !== constants.defaultSelect &&
      //   val.userName !== undefined
      // ) {
      //   arguments1[++a] = where(
      //     'assignedUserList',
      //     'array-contains',
      //     val.userName
      //   )
      // } else {
      //   arguments1[++a] = where('assignedUserList', 'array-contains', user)
      // }
      addOtherfilters(val, arguments1, a, loggedInUserDistrict, user)
      if (val.templateNAme !== constants.defaultSelect) {
        arguments1[++a] = where('templateName', '==', val.templateNAme)
      }
    } else {
      // filter for all jobs
      if (
        val.initialStatus === 'NoApprove' &&
        val.jobStatus !== 'Transmitted'
      ) {
        arguments1[++a] = where(
          'jobStatus',
          'in',
          constants.activeJobStatus
        )
      }
      // if (
      //   val.userName !== constants.defaultSelect &&
      //   val.userName !== undefined
      // ) {
      //   arguments1[++a] = where(
      //     'assignedUserList',
      //     'array-contains',
      //     val.userName
      //   )
      // }

      addOtherfilters(val, arguments1, a, loggedInUserDistrict)

      if (val.templateNAme !== constants.defaultSelect) {
        arguments1[++a] = where('templateName', '==', val.templateNAme)
      }
    }
    if (val.jobStatus !== constants.defaultSelect) {
      if (Array.isArray(val.jobStatus)) {
        arguments1[++a] = where('jobStatus', 'in', val.jobStatus)
      } else {
        arguments1[++a] = where('jobStatus', '==', val.jobStatus)
      }
    }
    const standTemplateQuery = query.apply(null, arguments1)
    return await getDocs(standTemplateQuery)
  }
}

const addOtherfilters = (val, arguments1, a, loggedInUserDistrict, user) => {
  if (val.jobStatus !== constants.defaultSelect) {
    if (Array.isArray(val.jobStatus)) {
      arguments1[++a] = where('jobStatus', 'in', val.jobStatus)
    } else {
      arguments1[++a] = where('jobStatus', '==', val.jobStatus)
    }
  }

  if (
    val.customer !== constants.defaultForAccountLevel &&
    val.customer !== undefined &&
    val.customer !== constants.defaultSelect
  ) {
    arguments1[++a] = where('accountLevel1', '==', val.customer.toUpperCase())
  }

  if (
    val.orderNumber !== constants.defaultForAccountLevel &&
    val.orderNumber !== constants.defaultSelect
  ) {
    arguments1[++a] = where('orderNumber', '==', val.orderNumber)
  }

  if (val.deType !== constants.defaultSelect) {
    arguments1[++a] = where('dataEntryType', '==', val.deType)
  }
  const filteredArray = val.districts.filter(
    (e) => e !== constants.defaultSelect
  )
  val.districts = filteredArray

  if (val.districts.length > 0) {
    arguments1[++a] = where('districtId', 'in', val.districts)
  } else {
    arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
  }
}

export const updateBoxStatus = async (jobId, boxId, status, isBatch, boxes) => {
  const batch = writeBatch(firestoreLite)
  const actionTime = new Date()
  if (isBatch) {
    boxes.forEach(box => {
      const boxref = doc(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${box.skpBoxId}`)
      batch.update(boxref, { status: status, actionTs: actionTime })
    })
    return await batch.commit()
  } else {
    return updateDoc(doc(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`), { status: status, actionTs: actionTime })
  }
}

export const getBoxesForQC = async (jobId) => {
  const boxQuery = query(collection(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`), where('status', 'in', [constants.boxStatus.readyForQc, constants.boxStatus.qcInProcess]))
  return getDocs(boxQuery)
}

export const getFilesForBox = async (jobId, boxId) => {
  const fileQuery = query(collection(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}`))
  return getDocs(fileQuery)
}

export const updateBoxFlow = async (jobId, status, boxes, isApprove = true) => {
  const batch = writeBatch(firestoreLite)
  const actionTime = new Date()
  
  if (isApprove) {
    for (const boxId in boxes) {
      const boxref = doc(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`)
      batch.update(boxref, { status: status, boxInfo: boxes[boxId], actionTs: actionTime })
    }
  } else {
    for (const boxId in boxes) {
      const boxref = doc(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`)
      boxes[boxId].actionTs = actionTime
      batch.update(boxref, boxes[boxId])
    }
  }
  
  return await batch.commit()
}

export const updateBoxData = async (jobId, boxId, data) => {
  return updateDoc(doc(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`), data)
}

export const updateFilesForBox = async (jobId, boxId, data) => {
  const batch = writeBatch(firestoreLite)
  for (const fileKey in data) {
    const fileRef = doc(firestoreLite, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}/${fileKey}`)
    batch.update(fileRef, { fileInfo: data[fileKey] })
  }

  return await batch.commit()
}

// export const updateJobStatistics = async () => {
//   try {
//     const sourceCollectionRef = collection(firestoreLite, 'locations')
//     const snapshot = await getDocs(sourceCollectionRef)

//     let writeCount = 0
//     let batch = writeBatch(firestoreLite)

//     for (const document of snapshot.docs) {
//       const district = document.id
//       console.log(district)
//       const districtWiseJobData = await currentJobs(district)
//       console.log(districtWiseJobData)

//       if (districtWiseJobData) {
//         const collectionRef = collection(firestoreLite, 'gdeReports')
//         const createFileRef = doc(collectionRef, district)
//         batch.set(createFileRef, districtWiseJobData)
//         writeCount++
//         console.log(createFileRef)
//       }

//       if (writeCount === 500) {
//         await batch.commit()
//         // Reset the batch and write count
//         batch = writeBatch(firestoreLite)
//         writeCount = 0
//       }
//     }

//     // Commit any remaining batch
//     if (writeCount > 0) {
//       await batch.commit()
//     }

//     console.log('All updates completed.')
//   } catch (error) {
//     console.error('Error:', error)
//   }
// }

export const updateRequestDetails = async (requestId, updatedData) => {
  const requestRef = doc(firestoreLite, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, 
    requestId
  )

  try {
    await updateDoc(requestRef, updatedData)
    // eslint-disable-next-line
    console.log('Request updated successfully')
  } catch (error) {
    // eslint-disable-next-line
    console.error('Error updating request:', error)
    throw error // Re-throw to handle in the calling function
  }
}
export const getWmsFailedResp = async (transmittalId) => {
  const collectionData = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_WMSRESPONSE}`), where('transmittalId', '==', transmittalId))
  const transmittalSnapshot = await getDocs(collectionData)
  const transmittalData = transmittalSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return transmittalData
}
export const getwmsResponse = async (activityId) => {
  const collectionImg = query(collection(firestoreLite, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_WMSRESPONSE}`), where('activityId', '==', activityId))
  const imageSnapshot = await getDocs(collectionImg)
  const imageData = imageSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return imageData
}
export const getBulkImgeAPI = async () => {
  const apiDoc = await getDoc(doc(firestoreLite, skpApiSettings, GDE_SMART_CATALOG_BULK_BOX_TRANSMITTAL))
  const apiDocData = apiDoc.data()
  return apiDocData
}